module.exports = __webpack_public_path__ + "img/hand.bb4a5102.svg";